const CategoryList = (state = [], action) => {
    switch (action.type) {
        case  'SET_CATEGORY':
            return action.payload;
    }
    return state
}

export default CategoryList;




// WEBPACK FOOTER //
// ./src/reducers/CategoryList.js